import { gql } from '@apollo/client';
import { schema as orderSummarySchema } from '../queries/getOrderSummary';

export default gql`
  mutation addPromoCode($code: String!){
    addPromoCode(code: $code) { ${orderSummarySchema} }
  }
`;
